

const React = require("react");
require("./atoms.pc");

exports.classNames = {
};

const getDefault = (module) => module.default || module;

const addClass = (className, properties) => ({
  ...properties,
  className: properties.className ? properties.className + " " + className : className,
});

const castStyle = (value) => {
  const tov = typeof value;
  if (tov === "object" || tov !== "string") return value;
  return value.trim().split(";").reduce((obj, keyValue) => {
    const [key, value] = keyValue.split(":");
    if (!value || value === "undefined") return obj;
    const trimmedValue = value.trim();
    if (trimmedValue === "undefined") return obj;
    obj[key.trim()] = value && value.trim();
    return obj;
  }, {});
};

const getClassName = (className) => {
  return className ? className.split(" ").map(part => (
    "_61c565fb_" + part + " " +"_pub-61c565fb_" + part + " " +"_pub-11f16876_" + part + " " +part
  )).join(" ") : "";
};

const View = React.memo(React.forwardRef(function View(props, ref) {
  return React.createElement("div", {
      "ref": ref,
      "key": "267e94f1",
      "className": "" + "_267e94f1 _61c565fb _pub-61c565fb _pub-11f16876 " + getClassName((props.className && (props.className))) + " _61c565fb_text-body-caption _pub-61c565fb_text-body-caption _pub-11f16876_text-body-caption text-body-caption" + (props.themed ? " " + "_267e94f1 _61c565fb _pub-61c565fb _pub-11f16876 " + "_61c565fb_themed _pub-61c565fb_themed _pub-11f16876_themed themed" : ""),
    },
    (props.children && (props.children))
  );
}));
exports.View = View;

